import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';
import { updateServiceEmail } from '../../services/serviceManagementService';

const UpdateEmailDialog = ({ open, onClose, service, onUpdate }) => {
  const [newEmail, setNewEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!newEmail) {
      setError('Le nouvel email est obligatoire');
      return;
    }
    
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)) {
      setError('Format d\'email invalide');
      return;
    }
    
    if (service.email === newEmail) {
      setError('Le nouvel email est identique à l\'email actuel');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      await updateServiceEmail(service.id, service.email, newEmail);
      
      setSuccess(true);
      setNewEmail('');
      
      // Mettre à jour le service dans le composant parent
      if (onUpdate) {
        onUpdate({
          ...service,
          email: newEmail
        });
      }
      
      // Fermer le dialogue après 2 secondes
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 2000);
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'email:', error);
      setError(error.message || 'Erreur lors de la mise à jour de l\'email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? null : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Modifier l'email du service
      </DialogTitle>
      <DialogContent>
        {success ? (
          <Alert severity="success" sx={{ mt: 2 }}>
            L'email a été mis à jour avec succès!
          </Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            
            <Typography variant="subtitle1" gutterBottom>
              Service: {service?.name}
            </Typography>
            
            <TextField
              margin="dense"
              label="Email actuel"
              type="email"
              fullWidth
              value={service?.email || ''}
              disabled
              sx={{ mb: 2 }}
            />
            
            <TextField
              margin="dense"
              label="Nouvel email"
              type="email"
              fullWidth
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              disabled={loading}
              required
              autoFocus
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {success ? 'Fermer' : 'Annuler'}
        </Button>
        {!success && (
          <Button 
            onClick={handleSubmit} 
            variant="contained" 
            color="primary" 
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Mise à jour...
              </>
            ) : (
              'Mettre à jour'
            )}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default UpdateEmailDialog;
